import { LoadingOutlined } from "@ant-design/icons";

/** Branded splash used while the session is being restored. */
export function FullScreenLoader() {
	return (
		<div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-[var(--c-canvas)]">
			<span className="flex size-10 items-center justify-center rounded-xl bg-[var(--c-accent)] text-[15px] font-semibold text-white">
				M
			</span>
			<LoadingOutlined className="text-base text-[var(--c-text-muted)]" />
		</div>
	);
}
